/**
 * Compact "last seen" formatter — gives a short relative string for recent
 * activity and falls back to a date for anything older than a few weeks.
 * Pass `now` for deterministic testing.
 */
export function relativeTime(
  ms: number | null,
  locale: string,
  now: number = Date.now()
): string {
  if (!ms) return "—";
  const diff = now - ms;
  if (diff < 0) {
    // future timestamp (clock skew); fall through to date
    return new Date(ms).toLocaleDateString(locale, { year: "numeric", month: "short", day: "numeric" });
  }
  const min = 60_000;
  const hour = 60 * min;
  const day = 24 * hour;
  if (diff < min) return locale.startsWith("es") ? "ahora" : "just now";
  if (diff < hour) {
    const n = Math.floor(diff / min);
    return locale.startsWith("es") ? `hace ${n} min` : `${n}m ago`;
  }
  if (diff < day) {
    const n = Math.floor(diff / hour);
    return locale.startsWith("es") ? `hace ${n} h` : `${n}h ago`;
  }
  if (diff < 7 * day) {
    const n = Math.floor(diff / day);
    if (n === 1) return locale.startsWith("es") ? "ayer" : "yesterday";
    return locale.startsWith("es") ? `hace ${n} días` : `${n}d ago`;
  }
  return new Date(ms).toLocaleDateString(locale, { year: "numeric", month: "short", day: "numeric" });
}
